import { LogActivityModal } from './log-activity-modal';
import { PartyModal } from '../../party/modal/party-modal';
import { FunnelStageModel } from '../../funnel-stage/model/funnel-stage-model';
import { PartyDetailModal } from '../../party/modal/party-detail-modal';
import { ProductModal } from '../../product/modal/product-modal';
import { UserModal } from '../../user/modal/user-modal';
import { DepartmentModal } from '../../department/modal/department-modal';
import { DocumentModel } from './document-model';
import { FunnelProductModel } from './funnel-product-model';
import { DynamicDataModel } from '../../../shared/dynamic-form/model/dynamic-data-model';
import { PartnerModel } from '../../user/modal/partner-model';
import { CommonFunnelModal } from './commonFunnelModal';
import { FunnelCustomer } from './funnel-customer';
import { materialPropertyTypes } from '../../product-type/model/product-type.model';
import { FunnelSourceModal } from '../../funnel-source/modal/funnel-source-modal';
import { FunnelHistory } from './funnel-history';

export class FunnelModal {
  id: number;
  projectName: string;
  projectNumber:string;
  businessNo:number;
  address: string;
  visitPlace:string;
  assignedToId:number;
  assignedTo: UserModal;
  prospectCustomerId:number;
  projectStageId:number;
  oldProjectStageId:number;
  totalCount:number;
  hasBusinessAssociation:any;
  funnelCreatedById:number;
  digitalPlatformId:number;
  funnelCustomerTypeId:number;
  funnelReferenceId:number;
  funnelHistories:FunnelHistory;
  contactPerson: PartyDetailModal;
  funnelCreationDate: Date = new Date();
  funnelType: string;
  prospectCustomer: PartyModal;
  projectStage: FunnelStageModel;
  proposedProducts: ProductModal;
  referencedDocument: string;
  remark: string;
  tentativeSalesValue: number;
  timelineOfClosure: Date;
  isDeleted: boolean;
  details: Array<FunnelProductModel>;
  logActivities: Array<LogActivityModal>;
  partnerName: string;
  funnelCreatedBy: DepartmentModal;
  documentDetails: Array<DocumentModel>;
  productDetails: Array<FunnelProductModel>;
  moduleCustomFieldValues: Array<DynamicDataModel>;
  partnerId: PartnerModel;
  funnelCustomerType: CommonFunnelModal;
  digitalPlatform: any;
  funnelReference: FunnelSourceModal;
  customerDetail: FunnelCustomer;
  leadType: string;
  funnelIndiaMart: any;
  funnelItemDetails: Array<FunnelProductDetails>;
  segment: string;

  // angular use
  file: Array<File>;
  creationDate: string;
  closingDate: string;
  customerName: string;
  activity: string;
  stageName: string;
  staffName: string;
  salesValue: string;
  funnelHistory: string;
  funnelSourceString: string;
  productName: string;
  enquiryMessage: string;
}
export class FunnelProductDetails {
  id: number;
  item: ProductModal;
  itemTupleId:number;
  itemId:number;
  itemName:string;
  productCode:string;
  uom:string;
  secondaryUom:string;
  secondaryQuantity:number;
  shortDescription:string;
  longDescription:string;
  price: number;
  quantity: number;
  packsize: number;
  pack: number;
  gst: number;
  itemProperties: Array<ItemProperties>;
  hsnCode:string;
  packSizeUom:string;
  minQuantity:number;
  packSize:any;
}
export class ItemProperties {
  id: number;
  itemPropertyValues: Array<ItemPropertyValues>;
  name: string;
  abbreviation: string;
}
export class ItemPropertyValues {
  id: number;
  name: string;
}
